<template>
	<div>
		<aside class="search-btn">
			<!--  结算明细 -->
            <div >
                <div class="text-center margin-bottom-10">
                    <ButtonGroup shape="circle">
                        <Button v-for="(item,index) in btnsearch"
                                :key="index"
                                :type="itemstatus===item.value?'primary':'default'"
                                @click="handleBtn(item.value)">
                            {{item.label}}
                        </Button>
                    </ButtonGroup>
                </div>
                <compListCalendar v-if="formData.chosetype == 0"></compListCalendar>
                <compListIndex v-if="formData.chosetype == 1"></compListIndex>
            </div>
		</aside>
	</div>
</template>
<script>
import compListIndex from "../manage.js";
import compListCalendar from "./listcalendar.vue"


export default {
	components: {
		compListIndex,
        compListCalendar,
        
	},
	data() {
		return {
            itemstatus: 0,
			formData: {
                chosetype:'0',
			},
            btnsearch:[
                {value:0,label:'Calendar'},
                {value:1,label:'List'}
            ],
		}
	},
	computed: {
		columns() {
			return [

			]
		}
	},
	methods: {
		handleBtn(value) {
			// console.log(value)
            this.formData.chosetype = value
			this.itemstatus = value
		}
	},
}
</script>
